import { Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import TenantPage from 'components/common/TenantPage';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EquipmentColumns } from 'components/common/enhanced/common-headers';
import { useRef } from 'react';
import { PurgeButton } from 'components/helpers/PurgeButton';
import { PurgeLinksButton } from 'components/helpers/PurgeLinksButton';
import { NotOperatorRoles } from '../../../../constants';
import { useAppSelector } from 'app/store';
import { isTechnicianCoordinator } from 'components/helpers/IsTechnicianCoordinator';
import { isTechnician } from 'components/helpers/IsTechnician';
import { isDirector } from 'components/helpers/IsDirector';
import { isSupplier } from 'components/helpers/IsSupplier';
import { equipmentApi } from '../api';
import { useEquipmentIvdrOptions } from '../hooks';

export const Equipments = () => {
  const translationPrefix = 'pages.equipment.list';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);
  const groups = useAppSelector((state) => state.auth.groups);
  const { ivdrOptions } = useEquipmentIvdrOptions();

  const isDisabledEdit =
    isTechnicianCoordinator() || isTechnician() || isDirector() || isSupplier();

  const columns: GridColDef[] = EquipmentColumns(
    ivdrOptions.map((ivdrOption) => ivdrOption.display_name),
    datagridRefresh.current,
    NotOperatorRoles.some((role) => groups.includes(role))
  );

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <IsTenantAdministrator>
            <div className="flex justify-end items-center">
              <ButtonGroup>
                <Link to="new">
                  <Button variant="outlined" size="small">
                    <AddIcon />
                    {t(`${translationPrefix}.add`)}
                  </Button>
                </Link>
              </ButtonGroup>
              <PurgeButton service={equipmentApi.listService} refresh={datagridRefresh} />
              <PurgeLinksButton service={equipmentApi.listService} refresh={datagridRefresh} />
            </div>
          </IsTenantAdministrator>
        }>
        <div className="mt-6">
          <EnhancedDataGrid
            columns={columns}
            service={equipmentApi.listService}
            refresh={datagridRefresh}
            disableEdit={isDisabledEdit}
          />
        </div>
      </TenantPage>
    </>
  );
};

export default Equipments;
